export enum CommunityPartnerType {
    WORDPRESS = 0,
    SHOPIFY = 1,
    WIX = 2,
    PRESTASHOP = 3,
    WEBFLOW = 4,
    JOOMLA = 5,
    ODOO = 6,
    STORYBLOK = 7
}